const doc = [({"en":({"adminButtonHotelChildrenSetting":({"saveChildrenSetting":"Save settings", "saveNotesOnChildren":"Save notes"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;